import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from './AggregationBox.module.scss';

const AggregationBox = ({ title, children }) => {
  const [opened, setOpened] = useState(true);

  const toggleOpened = () => {
    setOpened(!opened);
  };

  return (
    <div className={cn(styles.aggregationBox, { [styles.opened]: opened })}>
      <h4 onClick={toggleOpened}>{title}</h4>
      <div className={styles.content}>
        {children}
      </div>
    </div>
  );
};

AggregationBox.propTypes = {
  title: PropTypes.string,
};

AggregationBox.defaultProps = {
  title: '',
};

export default AggregationBox;
